export function capitalizeFirstLetter(str: string) {
  if (str?.length > 0) {
    return str.charAt(0)?.toUpperCase() + str.slice(1);
  }
  return str;
}

/**
 * Converts an arbitrary string or number value into a URL-safe kebab-case slug.
 *
 * Examples:
 *   slugify("Tom Ford")   → "tom-ford"
 *   slugify("men/shoes")  → "men-shoes"
 *   slugify(42)           → "42"
 *
 * Intended for generating stable `data-ui-id` suffixes for dynamic elements
 * when no pre-existing stable ID is available.
 */
export function slugify(value: string | number): string {
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}
